// Same validator used on the server
import isEmail from 'validator/lib/isEmail';

import { isPhoneValid } from './common';
import { t } from '../services/translation/translation';

export const rules = {
  email: (value: string) => (!value || isEmail(value) ? undefined : t('form.errors.email')),
  required: { message: t('form.errors.required'), value: true },
  password: {
    message: t('form.errors.password'),
    value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
  },
  phone: (value: string) => (isPhoneValid(value) ? undefined : t('form.errors.phone')),
};
